import { useState } from 'react';
import { Container, Reveal, Section, SectionHead } from '@nexa/ui';
import { useCopy } from '@/core/i18n';
import { PmTabs } from './PmTabs.tsx';
import { KanbanView } from './views/KanbanView.tsx';
import { SprintView } from './views/SprintView.tsx';
import { WbsView } from './views/WbsView.tsx';

const VIEWS = [SprintView, KanbanView, WbsView];
const ID_PREFIX = 'pm';

/**
 * `#pm` — `template.html:837`.
 *
 * Khung 3 view: thiết kế khoá `height:400px; overflow:hidden` và xếp chồng 3 view `absolute`. Ở
 * đây `min-h-[400px]` + chiều cao tự do ở MỌI khổ (`reference.md` §2.2): ba view lệch chiều cao
 * nhau, và khoá cứng 400px chính là lý do thiết kế phải cắt nội dung.
 *
 * View không active dùng `hidden` chứ không `opacity-0` (design doc §6.3): `opacity:0` vẫn được
 * screen reader đọc và vẫn Tab vào được — lỗi của bản thiết kế. Đánh đổi đã chốt: mất hiệu ứng
 * mờ 0.35s. Đó là quyết định, không phải bỏ sót.
 *
 * `cv` bật `content-visibility` (design doc §8.4 tầng T1): section này nằm dưới màn đầu.
 */
export function ProjectMgmtSection() {
  const copy = useCopy();
  const [active, setActive] = useState(0);

  return (
    <Section
      id="pm"
      labelledBy="pm-heading"
      cv
      // Mồi content-visibility khai theo bậc trong `packages/ui/src/motion.css`, không ở đây.
      className="nx-cv-pm"
    >
      <Container>
        <Reveal className="flex flex-wrap items-end justify-between gap-10">
          <SectionHead
            id="pm-heading"
            eyebrow={copy.pm.eyebrow}
            heading={copy.pm.heading}
            lead={copy.pm.lead}
            maxWidth="56ch"
            // Thiết kế vẽ `#pm` bằng bậc chữ NHỎ hơn mặc định: h2 38px và lead 16.5px
            // (`template.html:842-843`). Xem `tokens.css` mục `--text-h2-compact`.
            headingSize="h2-compact"
            leadSize="lead-compact"
          />
          <PmTabs labels={copy.pm.tabs} active={active} onChange={setActive} idPrefix={ID_PREFIX} />
        </Reveal>

        <Reveal className="nx-rv-right mt-9 min-h-[400px] rounded-card border border-ink-100 bg-surface-muted p-6 shadow-frame">
          {VIEWS.map((View, index) => (
            <div
              key={copy.pm.tabs[index]}
              role="tabpanel"
              id={`${ID_PREFIX}-view-${String(index)}`}
              aria-labelledby={`${ID_PREFIX}-tab-${String(index)}`}
              hidden={active !== index}
            >
              <View />
            </div>
          ))}
        </Reveal>
      </Container>
    </Section>
  );
}
